import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { GlobalVar } from '../globals/global-var';

@Injectable({
  providedIn: 'root'
})
export class A03Guard implements CanActivate {

  constructor(private router: Router, private globalVar: GlobalVar) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    //console.log(this.globalVar.mine);
    if (this.globalVar.mine && this.globalVar.mine.permissionList && this.globalVar.mine.permissionList.length > 0) {
      for (let i = 0; i < this.globalVar.mine.permissionList.length; i++) {
        if ((this.globalVar.mine.permissionList[i].roleId == 'A03' && this.globalVar.mine.permissionList[i].e == true) || this.globalVar.mine.isAdmin == true) {
          return true;
        }
      }
    }

    this.router.navigate(['/page401']);
    //alert('權限不足，無法進入');
    return false;
  }
  
}
